import React from "react";

interface CalendarProps {
  color?: string;
  className?: string;
}

export const Calendar: React.FC<CalendarProps> = ({
  color = "#ffffff",
  className = "calendar",
}) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19" fill="none">
      <g clip-path="url(#clip0_4044_27093)">
        <path d="M10.5714 0.857143C10.5714 0.382143 10.9536 0 11.4286 0C11.9036 0 12.2857 0.382143 12.2857 0.857143V2.28571H13.7143C14.975 2.28571 16 3.31071 16 4.57143V5.14286V6.85714V16C16 17.2607 14.975 18.2857 13.7143 18.2857H2.28571C1.025 18.2857 0 17.2607 0 16V6.85714V5.14286V4.57143C0 3.31071 1.025 2.28571 2.28571 2.28571H3.71428V0.857143C3.71428 0.382143 4.09643 0 4.57143 0C5.04643 0 5.42857 0.382143 5.42857 0.857143V2.28571H10.5714V0.857143ZM14.2857 6.85714H1.71428V16C1.71428 16.3143 1.97143 16.5714 2.28571 16.5714H13.7143C14.0286 16.5714 14.2857 16.3143 14.2857 16V6.85714Z" fill="#28834C"/>
      </g>
      <defs>
        <clipPath id="clip0_4044_27093">
          <rect width="16" height="18.2857" fill={color} transform="matrix(-1 0 0 1 16 0)"/>
        </clipPath>
      </defs>
    </svg>
  );
}; 